// Analytics are disabled until the visitor explicitly accepts.
export const CONSENT_KEY = 'ccardenoc.analytics-consent.v1';
export const CONSENT_EVENT = 'analytics-consent-changed';
const TOKEN = process.env.REACT_APP_MIXPANEL_TOKEN;
let sdk;
let loading;
let revision = 0;

function storedConsent() {
  try {
    const value = localStorage.getItem(CONSENT_KEY);
    return ['accepted', 'rejected'].includes(value) ? value : null;
  } catch { return null; }
}
let consent = storedConsent();
export const getAnalyticsConsent = () => consent;

function clearLegacyStorage() {
  if (!TOKEN) return;
  try {
    localStorage.removeItem(`mp_${TOKEN}_mixpanel`);
    ['ev', 'pp', 'gr'].forEach(type => localStorage.removeItem(`__mpq_${TOKEN}_${type}`));
  } catch { /* Storage may be blocked by the browser. */ }
}
if (consent !== 'accepted') clearLegacyStorage();

function applyConsent(value) {
  consent = value;
  revision += 1;
  if (consent !== 'accepted') {
    sdk?.opt_out_tracking({ clear_persistence: true, delete_user: false });
    clearLegacyStorage();
  } else if (sdk) {
    sdk.opt_in_tracking({ track: false });
  }
  window.dispatchEvent(new Event(CONSENT_EVENT));
}

export function setAnalyticsConsent(value) {
  if (!['accepted', 'rejected'].includes(value)) return;
  try { localStorage.setItem(CONSENT_KEY, value); } catch { /* Keep this visit's choice in memory. */ }
  applyConsent(value);
}
window.addEventListener('storage', event => {
  if (event.key === CONSENT_KEY || event.key === null) applyConsent(storedConsent());
});

async function getSDK() {
  if (consent !== 'accepted' || !TOKEN) return null;
  if (!loading) {
    loading = import('mixpanel-browser').then(({ default: mixpanel }) => {
      if (consent !== 'accepted') { loading = null; return null; }
      mixpanel.init(TOKEN, {
        persistence: 'localStorage',
        track_pageview: false,
        autocapture: false,
        record_sessions_percent: 0,
        track_marketing: false,
        store_google: false,
        save_referrer: false,
        ip: false,
        property_blacklist: ['$current_url', '$referrer', '$initial_referrer'],
      });
      mixpanel.opt_in_tracking({ track: false });
      sdk = mixpanel;
      return sdk;
    }).catch(() => { loading = null; return null; });
  }
  return loading;
}

async function send(method, ...args) {
  if (consent !== 'accepted') return;
  if (process.env.NODE_ENV === 'development') {
    console.log('Mixpanel:', method, ...args);
    return;
  }
  const version = revision;
  const client = await getSDK();
  // Never replay events collected before consent or after its withdrawal.
  if (!client || consent !== 'accepted' || version !== revision) return;
  if (method === 'people.set') client.people.set(...args);
  else client[method](...args);
}

export const analytics = {
  track: (name, properties = {}) => send('track', name, {
    ...properties,
    timestamp: new Date().toISOString(),
    url: window.location.origin + window.location.pathname,
    viewport_size: `${window.innerWidth}x${window.innerHeight}`,
  }),
  identify: id => send('identify', id),
  setUserProperties: properties => send('people.set', properties),
  reset: () => send('reset'),
};
export default analytics;
